import {
    INVALID_ID,
    EMPTY_STRING,
    INVALID_DATE,
} from '@Utils/constants'

// List of all Erf Module Selectors
export const getDefaultFilters = ({ hrErfList }) => hrErfList.searchFilter;
export const getListPageTitle = ({ hrErfList }) => hrErfList.searchLabel;
export const getListAlertModal = ({ hrErfList }) => hrErfList.alert;
export const getListConfirmModal = ({ hrErfList }) => hrErfList.confirmModal;
export const getUserPosition = ({ hrErfList }) => hrErfList.userPosition;

// Table selectors
export const getCurrentPage = ({ hrErfList }) => hrErfList.searchFilter.Pagination.Page;
export const getSortModel = ({ hrErfList }) => hrErfList.resultTable.appliedFilter.Pagination.Sort;
export const getRowsPerPage = ({ hrErfList }) => hrErfList.resultTable.rowsPerPage;
export const isTableLoading = ({ hrErfList }) => hrErfList.resultTable.loading;
export const getTableData = ({ hrErfList }) => hrErfList.resultTable.data;
export const getTotalCount = ({ hrErfList }) => hrErfList.resultTable.totalCount;
export const getTableSelectedRows = ({ hrErfList }) => hrErfList.resultTable.selectedRows;

// Erf Add Form
export const getAddFormData = ({ hrErfAdd }) => hrErfAdd.addForm;
export const getAlertModalData = ({ hrErfAdd }) => hrErfAdd.alert;
export const getShowLoading = ({ hrErfAdd }) => hrErfAdd.loading;
export const getddlData = ({ hrErfAdd }) => hrErfAdd.approverddl;
export const getHolidayDates = ({ hrErfAdd }) => hrErfAdd.holidayDates;

// Erf Detail Form
export const hasLoadedData = ({ hrErfDetail }) => hrErfDetail.hasLoadedData;
export const getFormTitle = ({ hrErfDetail }) => hrErfDetail.title;
export const getDetailData = ({ hrErfDetail }) => hrErfDetail.detailForm;
export const getLoanLedgerData = ({ hrErfDetail }) => hrErfDetail.ErfLedger;
export const getEditable = ({ hrErfDetail }) => hrErfDetail.isEditable;
export const getDetailMode = ({ hrErfDetail }) => hrErfDetail.mode;
export const getDetailAlertModal = ({ hrErfDetail }) => hrErfDetail.alert;
export const getDetailConfirmModal = ({ hrErfDetail }) => hrErfDetail.confirmModal;

export const validateAddForm = (values) => {
    let errors = {};

    if (values.departmentid === INVALID_ID || isNaN(values.departmentid)) {
        errors[`departmentid`] = 'Department Name is required!'
    }

    if (values.purposeofRequest === EMPTY_STRING) {
         errors[`purposeofRequest`] = 'Purpose of Request is required!'
    }
    
    if (values.reasonofRequest === EMPTY_STRING) {
        errors[`reasonofRequest`] = 'Reason of Request is required!'
    }

    if ( values.hiringManager === INVALID_ID) {
        errors[`hiringManager`] = 'Hiring Manager is required!'
    }

    if ( values.jobTitleID === INVALID_ID) {
        errors[`jobTitleID`] = 'Job Title is required!'
    }
    
    if ( values.jobLevelID === INVALID_ID || isNaN(values.jobLevelID) ) {
        errors[`jobLevelID`] = 'Job Level is required!'
    }

    if (values.jobPostingStatus === EMPTY_STRING) {
        errors[`jobPostingStatus`] = 'Job Posting is required!'
    }

    if (values.projectAssignment === EMPTY_STRING || values.projectID) {
        errors[`projectAssignment`] = 'Project Assignment is required!'
    }

    if (values.projectLeader === EMPTY_STRING) {
        errors[`projectLeader`] = 'Project Leader is required!'
    }

    if (values.basicRequirements === EMPTY_STRING) {
        errors[`basicRequirements`] = 'Basic Requirements is required!'
    }

    if (values.skillsNeeded === EMPTY_STRING) {
        errors[`skillsNeeded`] = 'Skills Needed is required!'
    }

    if (values.headcountNo < 1) {
        errors[`headcountNo`] = 'Headcount must be greater than or equal to one!';
    }
    
    if (values.EquipmentType === EMPTY_STRING) {
        errors[`EquipmentType`] = 'Equipment Type is required!'
    }

    if (values.EquipmentArrayIDS.length === INVALID_ID) {
        errors[`EquipmentArrayIDS`] = 'Equipment is required!'
    }
    return errors;
}

export const validateEditForm = (values) => {
    let errors = {};

    if (values.departmentID === INVALID_ID || isNaN(values.departmentID)) {
        errors[`departmentID`] = 'Department Name is required!'
    }

    if (values.purposeofRequest === INVALID_ID || isNaN(values.purposeofRequest)) {
         errors[`purposeofRequest`] = 'Purpose of Request is required!'
    }
    
    if (values.reasonofRequest === EMPTY_STRING) {
        errors[`reasonofRequest`] = 'Reason of Request is required!'
    }

    if ( values.hiringManagerID === INVALID_ID) {
        errors[`hiringManagerID`] = 'Hiring Manager is required!'
    }

    if ( values.jobTitleID === INVALID_ID || isNaN(values.jobTitleID)) {
        errors[`jobTitleID`] = 'Job Title is required!'
    }
    
    if ( values.jobLevelID === INVALID_ID || isNaN(values.jobLevelID) ) {
        errors[`jobLevelID`] = 'Job Level is required!'
    }

    if (values.jobPostingStatus === EMPTY_STRING) {
        errors[`jobPostingStatus`] = 'Job Posting is required!'
    }

    if (values.projectID === EMPTY_STRING || values.projectID === INVALID_ID) {
        errors[`projectID`] = 'Project Assignment is required!'
    }

    if (values.projectLeaderID === EMPTY_STRING || values.projectLeaderID === INVALID_ID) {
        errors[`projectLeaderID`] = 'Project Leader is required!'
    }

    if (values.basicRequirements === EMPTY_STRING) {
        errors[`basicRequirements`] = 'Basic Requirements is required!'
    }

    if (values.skillsNeeded === EMPTY_STRING) {
        errors[`skillsNeeded`] = 'Skills Needed is required!'
    }

    if (values.headCountno < 1) {
        errors[`headCountno`] = 'Headcount must be greater than or equal to one!';
    }
    
    if (values.equipmentType === EMPTY_STRING) {
        errors[`equipmentType`] = 'Equipment Type is required!'
    }

    if (values.EquipmentArrayIDS.length === INVALID_ID) {
        errors[`EquipmentArrayIDS`] = 'Equipment is required!'
    }
    
    return errors;
}